import { useEffect, useRef, useState } from "react";
import { useForm, ValidationError } from "@formspree/react";

interface Props {
  inline?: boolean;
}

const FeedbackWidget = ({ inline = false }: Props) => {
  const [open, setOpen] = useState(false);
  const [state, handleSubmit] = useForm("mzdoalrl");
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handle = (e: MouseEvent) => {
      if (widgetRef.current && !widgetRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, [open]);

  useEffect(() => {
    if (!state.succeeded) return;
    const t = setTimeout(() => setOpen(false), 2500);
    return () => clearTimeout(t);
  }, [state.succeeded]);

  if (inline) {
    return (
      <div className="feedback-inline">
        {state.succeeded ? (
          <p className="feedback-thanks">Thanks for your feedback!</p>
        ) : (
          <form className="feedback-form" onSubmit={handleSubmit}>
            <textarea
              name="message"
              className="feedback-input"
              placeholder="Tell us what you think…"
              rows={3}
              required
            />
            <ValidationError field="message" prefix="Message" errors={state.errors} />
            <button
              type="submit"
              className="feedback-submit"
              disabled={state.submitting}
            >
              {state.submitting ? "Sending…" : "Send feedback"}
            </button>
          </form>
        )}
      </div>
    );
  }

  return (
    <div className="feedback-widget" ref={widgetRef}>
      <button
        className={"feedback-trigger" + (state.succeeded ? " is-done" : "")}
        onClick={() => !state.succeeded && setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="true"
      >
        {state.succeeded ? "Thanks!" : "Feedback"}
      </button>

      <div className={"feedback-panel" + (open ? " is-open" : "")} aria-hidden={!open}>
        {state.succeeded ? (
          <p className="feedback-thanks">Thanks for your feedback!</p>
        ) : (
          <form className="feedback-form" onSubmit={handleSubmit}>
            <textarea
              name="message"
              className="feedback-input"
              placeholder="Tell us what you think…"
              rows={3}
              required
            />
            <ValidationError field="message" prefix="Message" errors={state.errors} />
            <button
              type="submit"
              className="feedback-submit"
              disabled={state.submitting}
            >
              {state.submitting ? "Sending…" : "Send"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackWidget;
